
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/alerting",
      function () {
        return require("private-next-pages/syncs/alerting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/alerting"])
      });
    }
  